import axiosClient from "./axios";

/**
 * Token Servisi
 * 
 * Bu servis Token işlemleri için gerekli API çağrılarını içerir.
 * Backend API: /tokens/*
 */

/**
 * Token istatistiklerini getir
 * @returns {Promise} - API yanıtı
 * @example
 * {
 *   "success": true,
 *   "stats": {
 *     "current_balance": "940.01",
 *     "lifetime_earned": "1000.01",
 *     "lifetime_spent": "60.00",
 *     "total_transactions": 7,
 *     "total_purchases": 0,
 *     "total_spending": 6
 *   }
 * }
 */
export const getTokenStats = async () => {
  try {
    const response = await axiosClient.get(`/tokens/stats`);
    return response.data;
  } catch (error) {
    console.error("Token istatistikleri alınırken hata:", error);
    throw error;
  }
};

